import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/auth.service';
import { Button, Input, Toast } from '../components/common';
import './Login.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [toast, setToast] = useState({
    isVisible: false,
    message: '',
    type: 'error' as 'success' | 'error'
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setToast({
        isVisible: true,
        message: 'Ingresa tu correo electrónico o teléfono',
        type: 'error'
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await authService.requestPasswordReset(email);

      if (result.success) {
        setIsSuccess(true);
        setToast({
          isVisible: true,
          message: 'Revisa tu correo electrónico',
          type: 'success'
        });
      }
    } catch (error: any) {
      setToast({
        isVisible: true,
        message: error.message || 'Error al procesar la solicitud',
        type: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <Toast
        message={toast.message}
        type={toast.type}
        isVisible={toast.isVisible}
        onClose={() => setToast(prev => ({ ...prev, isVisible: false }))}
      />

      {/* Fondo con efecto */}
      <div className="login-background">
        <div className="login-bg-shape shape-1"></div>
        <div className="login-bg-shape shape-2"></div>
        <div className="login-bg-shape shape-3"></div>
      </div>

      {/* Card */}
      <div className="login-container">
        <div className="login-card">
          {/* Header */}
          <div className="login-header">
            <div className="login-logo" style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
              <span className="logo-icon">DNA</span>
            </div>
            <h1 className="login-title">
              {isSuccess ? 'Correo Enviado' : 'Recuperar Contraseña'}
            </h1>
            <p className="login-subtitle">
              {isSuccess
                ? 'Revisa tu bandeja de entrada'
                : 'Ingresa tu correo para recibir instrucciones'
              }
            </p>
          </div>

          {!isSuccess ? (
            /* Formulario */
            <form className="login-form" onSubmit={handleSubmit}>
              <Input
                label="Correo electrónico o teléfono"
                type="text"
                name="email"
                placeholder="usuario@ejemplo.com o 5512345678"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                leftIcon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                }
                autoComplete="email"
              />

              <Button
                type="submit"
                variant="primary"
                fullWidth
                isLoading={isSubmitting}
              >
                Enviar Instrucciones
              </Button>

              <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <Link
                  to="/login"
                  style={{
                    color: 'var(--accent-primary)',
                    textDecoration: 'none',
                    fontSize: 'var(--font-size-sm)'
                  }}
                >
                  Volver al inicio de sesión
                </Link>
              </div>
            </form>
          ) : (
            /* Mensaje de éxito */
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'rgba(34, 197, 94, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#22c55e"
                  strokeWidth="2"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>

              <p style={{
                color: 'var(--text-secondary)',
                marginBottom: '24px',
                lineHeight: '1.6'
              }}>
                Si existe una cuenta asociada a <strong style={{ color: 'var(--text-primary)' }}>{email}</strong>,
                recibirás un correo con instrucciones para restablecer tu contraseña.
              </p>

              <p style={{
                color: 'var(--text-muted)',
                fontSize: 'var(--font-size-sm)',
                marginBottom: '24px'
              }}>
                El enlace expirará en 1 hora.
              </p>

              <Link to="/login">
                <Button variant="primary" fullWidth>
                  Volver al inicio de sesión
                </Button>
              </Link>
            </div>
          )}

          {/* Footer */}
          <div className="login-footer">
            <p className="login-footer-text">
              Sistema de gestión de estados de cuenta
            </p>
          </div>
        </div>

        {/* Info extra */}
        <div className="login-info">
          <p>¿No recibiste el correo? Revisa tu carpeta de spam</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
